import { templateStrings } from "../../../../Constant";

const validateExpenses = (formState) => {
  const form = {};
  if (formState.isNextClicked) {
    templateStrings.expenseArray.forEach((expense) => {
      if (formState[expense.name].applicable
        && !(formState[expense.name].amount || formState[expense.name].percentage)) {
        form[expense.name] = "Required";
      }
    });
  }
  return form;
};

export default validateExpenses;
